import { SubscriptionActionTypes } from 'routes/Search/ManagementPanel/routes/Subscriptions/modules/actions';
import { SubscriptionActionTypes as SeatActionTypes } from 'routes/Search/ManagementPanel/routes/Seats/modules/actions';

import { AppActionTypes } from './actions';
import { normalizeDiscounts } from './utils';

import Constants from './constants';

const CLEAN_STATUS = 'CLEAN_STATUS';

const initialState = {
  print: {
    mode: Constants.PRINT_MODE_NONE,
    showModal: false,
    modalIsLoading: false,
    printOption: Constants.PRINT_MODE_PROFILE_AND_SOURCES,
  },
  subscriptions: [],
  user: window.___INITIAL_STATE__.user || null,
  permissionArray: window.___INITIAL_STATE__.permissionArray || [],
  paymentMethod: window.___INITIAL_STATE__.paymentMethod || {
    is_chargeable: false,
  },
  organization: window.___INITIAL_STATE__.organization || null,
  organizationSettings: null,
  members: new Map(),
  pendingMembers: new Map(),
  discounts: [],

  voucher: null,
  promo_code: null,

  isFetching: false,
  isFetchingUser: false,
  isFetchingMembers: false,
  isFetchingOrganization: false,
  isUpdatingOrganization: false,
  isFetchingPaymentMethod: false,
  isUpdatingPaymentMethod: false,
  isFetchingDiscounts: false,
  isApplyingDiscount: false,
  isFetchingOrganizationSettings: false,
  isUpdatingOrganizationSettings: false,
  isCreatingStripeToken: false,

  stripeTokenStatus: null,
  initialStartModal: false,
  organizationSettingsStatus: null,
  applyingDiscountStatus: null,
  organizationStatus: null,
  fetchingMembersStatus: null,
  fetchingDiscounts: null,
  paymentStatus: null,
  status: '',
  serverErrorByField: null,

  appLoaded: true,
  loaderProgress: 0,
  subscriptionsQuantity: 0,
};

const ACTION_HANDLERS = {
  [AppActionTypes.OPEN_PRINT_MODAL]: state => {
    return {
      ...state,
      print: {
        ...state.print,
        showModal: true,
        modalIsLoading: false,
        printOption: Constants.PRINT_MODE_PROFILE_AND_SOURCES,
        mode: Constants.PRINT_MODE_NONE,
      },
    };
  },
  [AppActionTypes.CLOSE_PRINT_MODAL]: state => {
    return {
      ...state,
      print: {
        ...state.print,
        showModal: false,
        mode: Constants.PRINT_MODE_NONE,
      },
    };
  },
  [AppActionTypes.SELECT_PRINT_OPTION]: (state, action) => {
    return {
      ...state,
      print: {
        ...state.print,
        printOption: action.payload,
      },
    };
  },
  [AppActionTypes.PERFORM_PRINT_REQUEST]: state => {
    return {
      ...state,
      print: {
        ...state.print,
        modalIsLoading: true,
        mode: state.print.printOption,
      },
    };
  },
  [AppActionTypes.PERFORM_PRINT_SUCCESS]: state => {
    return {
      ...state,
      print: {
        ...state.print,
        modalIsLoading: false,
        showModal: false,
      },
    };
  },
  [AppActionTypes.INC_SEARCH_LOADER]: (state, action) => {
    return {
      ...state,
      loaderProgress: action.payload,
    };
  },
  [AppActionTypes.STARTUP_COMPLETED]: state => {
    return {
      ...state,
      appLoaded: true,
    };
  },
  [CLEAN_STATUS]: (state, action) => Object.assign({}, state, { status: null }), // FIXME: Why we need that?

  [AppActionTypes.UPDATE_PAYMENT]: (state, action) =>
    Object.assign({}, state, {
      isFetchingPaymentMethod: false,
      lastOrganizationStatus: null,
      paymentMethod: {
        ...action.payload.paymentMethod,
      },
    }),

  [AppActionTypes.FETCH_PAYMENT_METHOD_COMPLETED]: (state, action) =>
    Object.assign({}, state, {
      isFetching: false,
      isFetchingPaymentMethod: false,
      status: null,
      paymentStatus: null,
      paymentMethod: {
        ...action.payload.paymentMethod,
      },
    }),

  [AppActionTypes.FETCH_ORGANIZATION_METHOD_COMPLETED]: (state, action) =>
    Object.assign({}, state, {
      isFetching: false,
      isFetchingOrganization: false,
      lastOrganizationStatus: null,
      status: null,
      organization: {
        ...action.payload.organization,
      },
    }),
  [AppActionTypes.FETCH_ORGANIZATION_METHOD_FAILED]: (state, action) =>
    Object.assign({}, state, {
      isFetchingOrganization: false,
      lastOrganizationStatus: action.payload.status,
      isFetching: false,
      status: action.payload.status,
    }),
  [AppActionTypes.FETCH_ORGANIZATION_METHOD_WAITING]: state =>
    Object.assign({}, state, {
      isFetching: true,
      isFetchingOrganization: true,
    }),
  [AppActionTypes.FETCH_PAYMENT_METHOD_FAILED]: (state, action) =>
    Object.assign({}, state, {
      isFetching: false,
      status: action.payload.status,
      isFetchingPaymentMethod: false,
      paymentStatus: action.payload.status,
    }),
  [AppActionTypes.FETCH_PAYMENT_METHOD_WAITING]: state =>
    Object.assign({}, state, {
      isFetching: true,
      isFetchingPaymentMethod: true,
    }),

  [AppActionTypes.CREATE_PAYMENT_COMPLETED]: (state, action) =>
    Object.assign({}, state, {
      isUpdatingPaymentMethod: false,
      paymentStatus: null,
      paymentMethod: {
        ...action.payload.paymentMethod,
      },
      isFetching: false,
      status: null,
    }),
  [AppActionTypes.CREATE_PAYMENT_FAILED]: (state, action) =>
    Object.assign({}, state, {
      isUpdatingPaymentMethod: false,
      isCreatingStripeToken: false,
      isFetching: false,
      status: action.payload.status,
    }),
  [AppActionTypes.CREATE_PAYMENT_WAITING]: (state, action) =>
    Object.assign({}, state, {
      isUpdatingPaymentMethod: false,
      isFetching: true,
      status: action.payload.status,
    }),

  [AppActionTypes.CREATE_ORGANIZATION_COMPLETED]: (state, action) =>
    Object.assign({}, state, {
      isUpdatingOrganization: false,
      organizationStatus: null,
      organization: {
        ...action.payload.organization,
      },
      user: state.user
        ? {
            ...state.user,
            organization_active: action.payload.organization.is_active,
          }
        : null,
    }),
  [AppActionTypes.CREATE_ORGANIZATION_FAILED]: (state, action) =>
    Object.assign({}, state, {
      isUpdatingOrganization: false,
      organizationStatus: action.payload.status,
      serverErrorByField: action.payload.serverErrorByField,
    }),
  [AppActionTypes.CREATE_ORGANIZATION_WAITING]: (state, action) =>
    Object.assign({}, state, {
      serverErrorByField: null,
      isUpdatingOrganization: true,
      organizationStatus: action.payload.status,
    }),
  [AppActionTypes.FETCH_ORGANIZATION_USERS_WAITING]: state =>
    Object.assign({}, state, {
      isFetching: true,
      isFetchingMembers: true,
    }),
  [AppActionTypes.FETCH_ORGANIZATION_USERS_FAILED]: (state, action) =>
    Object.assign({}, state, {
      isFetching: false,
      isFetchingMembers: false,
      fetchingMembersStatus: action.payload.status,
    }),
  [AppActionTypes.FETCH_ORGANIZATION_USERS_COMPLETED]: (state, action) =>
    Object.assign({}, state, {
      members: new Map(action.payload.members.map(x => [x.username, x])),
      isFetching: false,
      isFetchingMembers: false,
    }),
  [AppActionTypes.FETCH_PENDING_ORGANIZATION_USERS_COMPLETED]: (state, action) =>
    Object.assign({}, state, {
      pendingMembers: action.payload.members,
    }),
  [AppActionTypes.ADD_MEMBER]: (state, action) => {
    state.members.set(action.payload.user.username, action.payload.user);
    return Object.assign({}, state, {
      members: new Map(state.members),
    });
  },
  [AppActionTypes.ADD_PENDING_MEMBER]: (state, action) => {
    state.pendingMembers.set(action.payload.user.username, action.payload.user);
    return Object.assign({}, state, {
      members: new Map(state.members),
    });
  },
  [SubscriptionActionTypes.ASSIGN_SUBSCRIPTION_COMPLETED]: (state, action) => {
    if (action.payload.username) {
      // FIXME: Always false?! because its payload.subscriptions?!
      const update = {
        members: new Map(state.members),
      };
      update.members.set(action.payload.username.username, action.payload.username);
      return Object.assign({}, state, update);
    }
    return Object.assign({}, state);
  },
  [AppActionTypes.FETCH_DISCOUNTS_COMPLETED]: (state, action) =>
    Object.assign({}, state, {
      isFetchingDiscounts: false,
      discounts: normalizeDiscounts(action.payload.discounts),
    }),
  [AppActionTypes.FETCH_DISCOUNTS_WAITING]: (state, action) =>
    Object.assign({}, state, {
      isFetchingDiscounts: true,
    }),

  [AppActionTypes.APPLY_DISCOUNT_COMPLETED]: (state, action) =>
    Object.assign({}, state, {
      discounts: [...state.discounts, ...normalizeDiscounts([action.payload.discount])],
      isApplyingDiscount: false,
      applyingDiscountStatus: null,
    }),
  [AppActionTypes.APPLY_DISCOUNT_WAITING]: (state, action) =>
    Object.assign({}, state, {
      isApplyingDiscount: true,
      applyingDiscountStatus: action.payload.msg,
    }),
  [AppActionTypes.APPLY_DISCOUNT_FAILED]: (state, action) =>
    Object.assign({}, state, {
      isApplyingDiscount: false,
      applyingDiscountStatus: action.payload.error,
    }),

  [AppActionTypes.FETCH_ORGANIZATION_SETTINGS_COMPLETED]: (state, action) =>
    Object.assign({}, state, {
      organizationSettings: { ...action.payload.settings },
      isFetchingOrganizationSettings: false,
      organizationSettingsStatus: null,
    }),
  [AppActionTypes.FETCH_ORGANIZATION_SETTINGS_WAITING]: (state, action) =>
    Object.assign({}, state, {
      isFetchingOrganizationSettings: true,
      organizationSettingsStatus: action.payload.msg,
    }),
  [AppActionTypes.FETCH_ORGANIZATION_SETTINGS_FAILED]: (state, action) =>
    Object.assign({}, state, {
      isFetchingOrganizationSettings: false,
      organizationSettingsStatus: action.payload.error,
    }),

  [AppActionTypes.UPDATE_ORGANIZATION_SETTINGS_COMPLETED]: (state, action) =>
    Object.assign({}, state, {
      organizationSettings: { ...action.payload.settings },
      isUpdatingOrganizationSettings: false,
      organizationSettingsStatus: null,
    }),
  [AppActionTypes.UPDATE_ORGANIZATION_SETTINGS_WAITING]: (state, action) =>
    Object.assign({}, state, {
      isUpdatingOrganizationSettings: true,
      organizationSettingsStatus: action.payload.msg,
    }),
  [AppActionTypes.UPDATE_ORGANIZATION_SETTINGS_FAILED]: (state, action) =>
    Object.assign({}, state, {
      isUpdatingOrganizationSettings: false,
      organizationSettingsStatus: action.payload.error,
    }),
  [AppActionTypes.SET_PRE_VOUCHER]: (state, action) =>
    Object.assign({}, state, {
      voucher: action.payload.voucher,
    }),
  [AppActionTypes.SET_PRE_PROMO]: (state, action) =>
    Object.assign({}, state, {
      initialStartModal: true,
      promo_code: action.payload.promo_code,
    }),

  [AppActionTypes.REMOVE_PROMO_CODE]: (state, action) =>
    Object.assign({}, state, {
      promo_code: null,
    }),

  [AppActionTypes.CREATE_STRIPE_TOKEN_IN_FAILED]: (state, action) =>
    Object.assign({}, state, {
      isCreatingStripeToken: false,
      stripeTokenStatus: action.payload.msg,
    }),
  [AppActionTypes.CREATE_STRIPE_TOKEN_IN_PROGRESS]: (state, action) =>
    Object.assign({}, state, {
      isCreatingStripeToken: true,
      stripeTokenStatus: action.payload.msg,
    }),
  [SeatActionTypes.UPDATE_AUTO_RENEWAL_PLAN_COMPLETED]: (state, action) => {
    return Object.assign({}, state, {
      organization: {
        ...state.organization,
        seat_plan: {
          ...state.organization.seat_plan,
          auto_renewal: action.payload.autoRenewalStatus,
          reduce_number: state.subscriptionsQuantity - action.payload.updatedSeats,
        },
      },
    });
  },
  [SeatActionTypes.FETCH_SUBSCRIPTIONS_COMPLETED]: (state, action) => {
    return Object.assign({}, state, {
      subscriptionsQuantity: action.payload.subscriptions.count,
    });
  },
};

export function appReducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}

export default {
  name: Constants.MODULE_NAME,
  reducer: appReducer,
};
